import Notes from "./Notes";
import { Tab, Tabs } from "@mui/material";
import Component from "components/Component";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as notesStore from "store/notes";

const TabbedTextNote = ({
  title,
  noteKey,
  tabData: inputTabs = [],
  emptyTabContent = <>{"No tabs"}</>,
  ...props
}) => {
  const [activeTabKey, setActiveTabKey] = useState(null);
  const [noteText, setNoteText] = useState(null);
  const legacyNoteText = useSelector(notesStore.selectNoteText(noteKey));
  const dispatch = useDispatch();

  const tabs = useMemo(() => {
    const seenKeys = new Set();
    return [
      ...inputTabs.map(({ key, ...rest }) => ({
        key: `${noteKey}.${key}`,
        ...rest,
      })),
      ...(legacyNoteText ? [{ key: noteKey, label: "Legacy" }] : []),
    ].filter(({ key }) => {
      if (seenKeys.has(key)) {
        return false;
      }
      seenKeys.add(key);
      return true;
    });
  }, [inputTabs, legacyNoteText, noteKey]);

  useEffect(() => {
    setActiveTabKey(activeTabKey ?? tabs?.[0]?.key);
  }, [tabs, activeTabKey]);

  const policyNoteText = useSelector(notesStore.selectNoteText(activeTabKey));
  useEffect(() => setNoteText(policyNoteText), [policyNoteText]);

  const update = (text) =>
    dispatch(notesStore.updateNoteText({ key: activeTabKey, text }));

  return (
    <Component title={title}>
      {tabs?.length ? (
        <>
          <Tabs
            value={activeTabKey ?? false}
            onChange={(_event, key) => setActiveTabKey(key)}
            sx={{ mt: "-24px", mb: 2, borderBottom: 1, borderColor: "divider" }}
            variant={"scrollable"}
          >
            {tabs.map(({ key, label }) => (
              <Tab key={key} label={label} value={key} />
            ))}
          </Tabs>
          <Notes
            title={null}
            value={noteText}
            update={update}
            xs_width={12}
            {...props}
          />
        </>
      ) : (
        emptyTabContent
      )}
    </Component>
  );
};

export default TabbedTextNote;
